export const parseJwtToken = (token: string) => {
  return JSON.parse(atob(token.split('.')[1]));
};
export const checkJwtTokenIsValid = (token: string): boolean => {
  if (!token) {
    return false;
  }

  const tokenData = parseJwtToken(token);

  const currentTimestamp = Math.floor(Date.now() / 1000);
  if (!tokenData.exp) {
    return true;
  }
  return tokenData.exp > currentTimestamp;
};
